function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import { useOverviewState, useOverviewDispatch } from '../../context/overview';
import { useTheme, Popover, Pressable, Box, HStack, Text, Circle, useBreakpointValue } from 'native-base';
import NotificationsIcon from '../iconButtons/NotificationsIcon';
import { isArrayValid } from '../utils/helpers';
import Activity from './Activity';
import { NOTIFICATIONS_TABS, NOTIFICATION_PREVIEW_LENGTH } from '../Constants';
const NotificationPopover = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const overviewState = useOverviewState();
  const overviewDispatch = useOverviewDispatch();
  const {
    unreadActivityCount,
    unreadMessagesCount,
    notifications
  } = overviewState;
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [selected, setSelected] = useState('Activity');
  const setTabsDisplay = tabItem => {
    const {
      name,
      isInUse
    } = tabItem;
    const isCurrentlySelected = name === selected;
    if (isInUse) {
      return /*#__PURE__*/React.createElement(Pressable, {
        onPress: () => setSelected(name)
      }, /*#__PURE__*/React.createElement(Box, {
        borderBottomColor: isCurrentlySelected ? colors.activity.border : '',
        borderBottomWidth: isCurrentlySelected ? '2' : '0',
        px: "4"
      }, /*#__PURE__*/React.createElement(HStack, {
        space: 1,
        py: "3"
      }, /*#__PURE__*/React.createElement(Text, {
        fontWeight: isCurrentlySelected ? 'bold' : '',
        color: colors.activity.text
      }, name), /*#__PURE__*/React.createElement(Circle, {
        bg: colors.activity.border,
        px: "2"
      }, /*#__PURE__*/React.createElement(Text, {
        color: colors.notification.icon
      }, unreadActivityCount)))));
    } else {
      return /*#__PURE__*/React.createElement(Box, {
        px: "4"
      });
    }
  };
  const setDisplayData = () => {
    let dataArr;
    const allowedTabNames = NOTIFICATIONS_TABS.map(tab => tab.name);
    if (!allowedTabNames.includes(selected)) {
      throw new Error('Invalid value selected');
    }
    if (selected === NOTIFICATIONS_TABS[0].name) {
      dataArr = notifications;
    }
    /*
    else if (selected === NOTIFICATIONS_TABS[1].name) {
      data = privateMessages;
    } else if (selected === NOTIFICATIONS_TABS[2].name) {
      data = privateMessagesSent;
    }
    */

    if (isArrayValid(dataArr)) {
      // display only 3 items in popover
      dataArr.length = NOTIFICATION_PREVIEW_LENGTH;
      const data = /*#__PURE__*/React.createElement(Popover.Body, {
        p: "1"
      }, dataArr.map(item => /*#__PURE__*/React.createElement(Activity, {
        key: item.id,
        activity: item,
        navigation: props.navigation,
        setIsPopoverOpen: setIsPopoverOpen,
        updateNotifications: updateNotifications,
        selected: selected
      })));
      return data;
    }
    return /*#__PURE__*/React.createElement(Popover.Body, {
      p: "1"
    }, /*#__PURE__*/React.createElement(Text, {
      alignSelf: "center"
    }, "You're up to date!"));
  };
  const updateNotifications = activityId => {
    overviewDispatch({
      type: 'SET_NOTIFICATIONS',
      payload: notifications.filter(item => item.id !== activityId)
    });
    overviewDispatch({
      type: 'SET_UNREAD_ACTIVITY_COUNT',
      payload: unreadActivityCount - 1
    });
  };
  const width = useBreakpointValue({
    base: '250px',
    '3xs': '330px',
    '2xs': '380px',
    xs: '430px',
    sm: '450px'
  });
  const left = useBreakpointValue({
    base: '0',
    '3xs': '10',
    sm: '10',
    '2sm': '0',
    md: '-8' // added this because popover was blocking bell icon with left='0' from '2sm' and above
  });

  return /*#__PURE__*/React.createElement(Popover, {
    isOpen: isPopoverOpen,
    onOpen: () => setIsPopoverOpen(true),
    onClose: () => setIsPopoverOpen(false),
    placement: "left",
    trigger: triggerProps => {
      if (props.orientation && props.orientation === 'vertical') {
        return /*#__PURE__*/React.createElement(Pressable, _extends({}, triggerProps, {
          p: 2,
          bg: colors.overview.button.bg,
          rounded: '3xl'
        }), /*#__PURE__*/React.createElement(NotificationsIcon, {
          unreadActivityCount: unreadActivityCount,
          unreadMessagesCount: unreadMessagesCount,
          iconColor: colors.notification.icon
        }));
      } else {
        return /*#__PURE__*/React.createElement(Pressable, _extends({}, triggerProps, {
          m: 2,
          p: 3,
          bg: colors.menu.header.button.icon.bg,
          rounded: '3xl',
          borderColor: colors.menu.header.button.border,
          borderWidth: 1
        }), /*#__PURE__*/React.createElement(NotificationsIcon, {
          unreadActivityCount: unreadActivityCount,
          unreadMessagesCount: unreadMessagesCount,
          iconColor: colors.menu.header.button.icon.text
        }));
      }
    }
  }, /*#__PURE__*/React.createElement(Popover.Content, {
    w: width,
    h: "100%",
    left: left
  }, /*#__PURE__*/React.createElement(Popover.CloseButton, null), /*#__PURE__*/React.createElement(Popover.Header, {
    py: "0"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 4
  }, NOTIFICATIONS_TABS.map(tab => setTabsDisplay(tab)))), setDisplayData(), /*#__PURE__*/React.createElement(Popover.Footer, null, /*#__PURE__*/React.createElement(Pressable, {
    w: "100%",
    px: "20",
    py: "2",
    borderWidth: 1,
    borderColor: colors.activity.border,
    borderRadius: 10,
    bg: "transparent",
    onPress: () => {
      setIsPopoverOpen(false);
      props.navigation.navigate('Notifications');
    },
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    color: colors.activity.border,
    fontWeight: "bold"
  }, "View All")))));
};
export default NotificationPopover;
//# sourceMappingURL=NotificationPopover.js.map